import config from "@/config";
import Axios from "@/utils/Axios";

const PaymentApis = {
  accelerateProducts: "/accelerator/product/list",
  heartCoinProducts: "/wenxin/product/list",
};

export const getAccelerateProducts = () => {
  return Axios.get(PaymentApis.accelerateProducts, {}, {}, config.creatorUrl);
};

export const getHeartCoinProducts = () => {
  return Axios.get(PaymentApis.heartCoinProducts, {}, {}, config.creatorUrl);
};
